<template>
    <div>
      <vue3-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="false"
        :paginate-elements-by-height="400"
        filename="FomoTicket"
        :pdf-quality="1.5"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        @beforeDownload="beforeDownload($event)"
        ref="html2Pdf"
      >
        <template v-slot:pdf-content>
          <div style="margin: 0; padding: 0; text-align: center;">
            <table style="width: 100%; border-collapse: collapse; text-align: center; border-radius: 15px; background: radial-gradient(circle, rgb(10, 2, 49) 20%, rgb(0, 0, 0) 100%); box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3); position: relative; padding: 20px;" class="table tcktable">
              <tbody>
                <tr v-for="(ticket, index) in ticketsTable" :key="index" style="page-break-inside: avoid;">
                  <td style="position: relative; padding: 10px; border-radius: 15px; overflow: hidden; border: 1px solid rgba(255, 255, 255, 0.1); background-color: rgba(255, 255, 255, 0.05); box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);">
  
                    <!-- Perforaciones simuladas (círculos) -->
                    <div style="position: absolute; top: 0; left: 0; height: 100%; width: 20px; background-color: rgba(255, 255, 255, 0.1); display: flex; flex-direction: column; justify-content: space-between; padding: 10px;">
                      <div style="width: 10px; height: 10px; background-color: #fff; border-radius: 50%;"></div>
                      <div style="width: 10px; height: 10px; background-color: #fff; border-radius: 50%;"></div>
                      <div style="width: 10px; height: 10px; background-color: #fff; border-radius: 50%;"></div>
                      <div style="width: 10px; height: 10px; background-color: #fff; border-radius: 50%;"></div>
                    </div>
  
                    <div style="border-top: 1px dashed #888; width: 90%; margin: 10px auto;"></div>
  
                    <!-- Logo, número de ticket y nombre del evento como marca de agua -->
                    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.05; font-family: 'Quicksand', sans-serif; color: #ffffff; text-transform: uppercase; text-align: center;">
                      
                      <!-- Logo en la parte superior -->
                      <img
                        src="https://gingopolisdjango.blob.core.windows.net/fomoapp/media/LOGOS%20FOMO%20TODAS%20LAS%20VARIACIONES-02.png"
                        alt="Fomoplanes Logo"
                        style="width: 150px; height: auto; margin-bottom: 20px;"
                      />
  
                      <!-- Número de ticket en el centro -->
                      <span style="font-size: 100px;">{{ invoice }}-{{ index }}</span>
  
                      <!-- Nombre del evento en la parte inferior -->
                      <span style="font-size: 50px; display: block; margin-top: 20px;">{{ event.name }}</span>
  
                    </div>
  
                    <!-- Elementos gráficos modernos (líneas diagonales) -->
                    <div style="position: absolute; top: 0; right: 0; height: 100%; width: 100px; background: linear-gradient(45deg, rgba(255, 255, 255, 0.05), rgba(0, 0, 0, 0.1)); transform: rotate(45deg); opacity: 0.5;"></div>
  
                    <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 10px;">
                      <div style="text-align: center;">
                        <img
                          :src="event.banner_url"
                          alt="Event Banner"
                          style="border-radius: 10px; object-fit: cover; border: 2px solid #333; width: 150px; height: 150px;"
                        />
                      </div>
  
                      <!-- Columna central con altura limitada y textos centrados -->
                      <div style="text-align: center; max-width: 300px; display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
                        <div style="margin-bottom: 10px;">
                          <img
                            src="https://gingopolisdjango.blob.core.windows.net/fomoapp/media/LOGOS%20FOMO%20TODAS%20LAS%20VARIACIONES-02.png"
                            alt="Fomoplanes Logo"
                            style="width: 100px; height: auto;"
                          />
                        </div>
                        <h1 style="color: #fff; font-size: 18px; font-family: 'Quicksand', sans-serif; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 5px;">
                          {{ event.name }}
                        </h1>
                        <h2 style="font-size: 14px; font-family: 'Raleway', sans-serif; color: #ddd; margin-bottom: 5px;">
                          {{ ticket.first_name }} {{ ticket.last_name }}
                        </h2>
  
                        <!-- Fecha y Asiento con íconos -->
                        <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
                          <div style="font-size: 14px; color: #fff;">
                            <i class="fas fa-calendar-alt" style="margin-right: 5px;"></i> Fecha de Inicio: {{ formatStartDate(event.start_date) }}
                          </div>
                          <div style="font-size: 14px; color: #fff;">
                            <i class="fas fa-chair" style="margin-right: 5px;"></i> Asiento: {{ ticket.seat_name }}
                          </div>
                        </div>
  
                        <p style="font-size: 12px; color: #bbb; margin-top: 10px;">
                          <i class="fas fa-map-marker-alt"></i> Ubicación: {{ event.location }}
                        </p>
                      </div>
  
                      <div style="text-align: center;">
                        <qr-code :size="120" :text="invoice + 'hash' + index" style="filter: drop-shadow(0px 0px 5px rgba(255, 255, 255, 0.5));"></qr-code>
                        <p style="font-size: 10px; color: #666; margin-top: 5px;">
                          {{ invoice }} | {{ index }}
                        </p>
                      </div>
                    </div>
  
                    <div style="position: absolute; top: 0; right: 10px; font-size: 10px; color: #999;">
                      Ticket No: {{ invoice }}-{{ index }}
                    </div>
  
                    <div style="position: absolute; top: 0; left: 20px; height: 100%; border-left: 1px dashed #888;"></div>
  
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </vue3-html2pdf>
    </div>
  </template>
  
  <script>
  import Vue3Html2pdf from "vue3-html2pdf";
  
  export default {
    name: "PdfGeneration",
    props: {
      ticketsTable: {
        type: Object,
      },
      event: {
        type: Object,
      },
      invoice: {
        type: Number,
      },
    },
    components: {
      Vue3Html2pdf,
    },
    mounted() {
      this.generateReport();
    },
    methods: {
      generateReport() {
        this.$refs.html2Pdf.generatePdf();
      },
      async beforeDownload({ html2pdf, options, pdfContent }) {
        var worker = await html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .output("blob")
          .then(function (data) {
            return data;
          });
        var file = new File([worker], "ticket.pdf");
        this.$emit("messageFromPdfGeneration", file);
      },
      formatStartDate(startDate) {
        const date = new Date(startDate);
        return date.toLocaleDateString(); 
      },
    },
  };
  </script>
  
  <style>
  .table {
    width: 100%;
    margin: 0 auto;
    border-spacing: 0px;
  }
  
  .tcktable {
    border-spacing: 0;
    width: 100%;
  }
  
  .ticket-info h1 {
    color: #fff;
    font-family: 'Quicksand', sans-serif;
    font-size: 18px;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  
  .ticket-info h2 {
    font-family: 'Raleway', sans-serif;
    color: #ddd;
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .ticket-info .date {
    font-size: 14px;
    color: #888;
    font-weight: bold;
  }
  
  .ticket-info p {
    font-size: 12px;
    color: #bbb;
    text-align: center;
  }
  
  .qr-code {
    padding: 5px;
  }
  
  .tcktable tr td {
    padding: 10px;
    border: 2px solid #333;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
  }
  </style>
  